import { Pipe, PipeTransform } from '@angular/core';



const resultLookup = {
  0: 'Mobile', //MOBILE(0),
  1: 'Softphone', //SOFT(1),
  2: 'Desktop', //DESKTOP(2),
  3: 'FXS', //FXS(3),
  4: 'External PBX', //EXTERNAL_PBX(4),
  //5: '', //??(5)
  6: 'Fax', //FAX(6),
  7: 'Voicemail', //VOICEMAIL(7),
  8: 'External', //EXTERNAL(8),
  9: 'Mobile External', //MOBILE_EXT(9),
  10: 'Confernce', //CONFERENCE(10),
  11: 'Queue', //QUEUE(11),
  //12: '', //??(12)
  13: 'Web', //WEB(13)
};



@Pipe({
  name: 'telepoCdrApTypePipe_Name'
})
export class TelepoCdrApTypePipe_Name implements PipeTransform {
  transform(value: string): any {
    
    return resultLookup[value] ?? "Phone Call";
  }
}
